import { useState } from "react";

const useSwipe = (onSwipeLeft: () => void, onSwipeRight: () => void, threshold: number = 75) => {
	const [start, setStart] = useState<number | null>(null);
	const [end, setEnd] = useState<number | null>(null);

	const handleStart = (clientX: number) => {
		setStart(clientX);
		setEnd(null);
	};

	const handleMove = (clientX: number) => {
		if (start !== null) {
			setEnd(clientX);
		}
	};

	const handleEnd = () => {
		if (start === null || end === null) return;

		const distance = start - end;

		if (distance > threshold) {
			onSwipeLeft();
		} else if (distance < -threshold) {
			onSwipeRight();
		}

		setStart(null);
		setEnd(null);
	};

	return {
		handleTouchStart: (e: React.TouchEvent) => {
			handleStart(e.targetTouches[0].clientX);
		},
		handleTouchMove: (e: React.TouchEvent) => {
			handleMove(e.targetTouches[0].clientX);
		},
		handleTouchEnd: (e: React.TouchEvent) => {
			handleEnd();
		},
		handleMouseDown: (e: React.MouseEvent) => {
			handleStart(e.clientX);
		},
		handleMouseMove: (e: React.MouseEvent) => {
			handleMove(e.clientX);
		},
		handleMouseUp: (e: React.MouseEvent) => {
			handleEnd();
		},
	};
};

export default useSwipe;
